import { BreadcrumbItem } from "./PageHeaderMapping";

export interface NavigationState {
    breadcrumbs?: BreadcrumbItem[];
    selectedWorklistsTab? : string;
}

export const emptyNavigationState: NavigationState = {
    breadcrumbs: []
}